const initialState = {
  loading: false,
};

export default function certificateUserReducer(state = initialState, action) {
  switch (action.type) {
    case "CERTIFICATE_USER_ERROR":
    case "CERTIFICATE_USER_FETCH_REQUESTED":
      return { ...state, loading: true };
    case "CERTIFICATE_USER_FETCHED":
      return { ...action.data, loading: false };
    default:
      return state;
  }
}
